import {cache0} from "../../utils/cache0";

export const isDevXd = cache0(() => {
    return typeof localStorage === "undefined" || localStorage.getItem("DEV_XD") && localStorage.getItem("DEV_XD") === '1';
});
